import { DocType } from "../shared"

export enum AssuredPersonRelationship {
  TITULAR = 'titular',
  CONYUGE = 'conyuge',
  HIJO = 'hijo'
}

export enum AssuredPersonStatus {
  ACTIVE = 'active',
  REMOVED = 'removed',
  SUSPENDED = 'suspended',
}

export interface AssuredPersonRequest {
  name: string
  docType: DocType
  docNumber: string
  dateOfBirth?: Date | null
  relationship: AssuredPersonRelationship
}

export interface AssuredPersonProps {
  id?: string
  contractId: string
  name: string
  dateOfBirth?: Date | null
  status: AssuredPersonStatus
  docType: DocType
  docNumber: string
  relationship: AssuredPersonRelationship
  notes?: string | null
  removedAt?: Date | null
  createdAt?: Date
  updatedAt?: Date
  createdBy?: string | null
  updatedBy?: string | null
}

export class AssuredPerson {
  public id?: string
  public contractId: string
  public name: string
  public dateOfBirth: Date
  public status: AssuredPersonStatus
  public docType: DocType
  public docNumber: string
  public relationship: AssuredPersonRelationship
  public notes?: string | null
  public removedAt?: Date | null
  public createdAt?: Date
  public updatedAt?: Date
  public createdBy?: string | null
  public updatedBy?: string | null

  constructor(props: AssuredPersonProps) {
    this.id = props.id
    this.contractId = props.contractId
    this.name = props.name
    this.dateOfBirth = props.dateOfBirth ? new Date(props.dateOfBirth) : new Date()
    this.status = props.status
    this.docType = props.docType
    this.docNumber = props.docNumber
    this.relationship = props.relationship
    this.notes = props.notes
    this.removedAt = props.removedAt ? new Date(props.removedAt) : undefined
    this.createdAt = props.createdAt ? new Date(props.createdAt) : undefined
    this.updatedAt = props.updatedAt ? new Date(props.updatedAt) : undefined
    this.createdBy = props.createdBy
    this.updatedBy = props.updatedBy
  }
}

export const formatAssuredPersonStatus = (status: AssuredPersonStatus): string => {
  const statuses: Record<AssuredPersonStatus, string> = {
    [AssuredPersonStatus.ACTIVE]: 'Activo',
    [AssuredPersonStatus.REMOVED]: 'Removido',
    [AssuredPersonStatus.SUSPENDED]: 'Suspendido',
  }
  return statuses[status] || status
}

export const getAssuredPersonStatusColor = (status: AssuredPersonStatus): string => {
  switch (status) {
    case AssuredPersonStatus.ACTIVE:
      return 'bg-green-100 text-green-800 hover:bg-green-100'
    case AssuredPersonStatus.REMOVED:
      return 'bg-red-100 text-red-800 hover:bg-red-100'
    case AssuredPersonStatus.SUSPENDED:
      return 'bg-orange-100 text-orange-800 hover:bg-orange-100'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

export const formatAssuredPersonRelationship = (relationship: AssuredPersonRelationship): string => {
  const relMap: Record<AssuredPersonRelationship, string> = {
    [AssuredPersonRelationship.TITULAR]: 'Titular',
    [AssuredPersonRelationship.CONYUGE]: 'Cónyuge',
    [AssuredPersonRelationship.HIJO]: 'Hijo/a'
  }
  return relMap[relationship] || relationship
}

